import React, { useEffect } from 'react'
import $ from 'jquery';
// CSS
import '../assets/css/preloader.css'

export default function Preloader() {
  useEffect(() => {
    setTimeout(() => {
      $('.preloader').addClass("hide");
      setTimeout(() => {
        $('.preloader').hide();
      }, 500)
    }, 1000)
  }, [])
  return (
    <div className="preloader">
      <div></div>
    </div>
  )
}
